import { API_CODE } from "../../../controller/api/constants"
import { getApi, postApi, uploadApi } from "../../../controller/api/get"

export const getList = async (cookie) => {
  const response = await getApi(cookie, API_CODE.GET_BANNER, {
    isGetAll: true
  })

  if (response) {
    return {
      list: response,
      total: response.length,
      totalPage: 1
    }
  }
  return undefined
}

export const getListBannerGroup = async (cookie) => {
  const response = await getApi(cookie, API_CODE.GET_BANNER_GROUP, {})

  if (response) {
    return {
      list: response,
      total: response.length,
      totalPage: 1
    }
  }
  return undefined
}

export const getBannerDetail = async (cookie, id) => {
  const response = await getApi(cookie, API_CODE.GET_BANNER_DETAIL, {
    id: id
  })

  if (response) {
    return response
  }
  return undefined
}

export const update = async (cookie, id, action, data) => {
  const requestData = {
    id: id,
    action: action,
    data: data
  }

  const response = await postApi(cookie, API_CODE.POST_UPDATE_BANNER, requestData)

  return response
}

export const updateDetail = async (cookie, id, action, data) => {
  const requestData = {
    id: id,
    action: action,
    data: data
  }

  const response = await postApi(cookie, API_CODE.POST_UPDATE_BANNER_DETAIL, requestData)

  return response
}

export const add = async (cookie, image, title, subTitle, subTitle2, group) => {
  const requestData = {
    groupId: group > 0 ? group : undefined,
    detail: undefined,
    image: image,
    title: title,
    subTitle: subTitle,
    subTitle2: subTitle2,
  }
  const response = await postApi(cookie, API_CODE.POST_ADD_BANNER, requestData)

  return response
}

export const upload = async (name, type, ticket) => {
  const response = await uploadApi(ticket, name, type)

  return response
}